import styled from 'styled-components';

export const StyledListItemContent = styled.div`
  height: calc(100vh - 301px);
  overflow-y: auto;
  .list-content-item {
    background-color: #ffffff;
    border: 1px solid #f4f4f4;
    border-block-end: 1px solid #f4f4f4 !important;
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    > p {
      margin-bottom: 0;
      width: 150px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .ant-flex p {
      margin-bottom: 0;
      max-width: calc(100% - 32px);
    }
  }
  .list-content-item-title {
    margin-bottom: 8px;
    display: block;
    font-size: 14px;
    color: #6b7083;
    line-height: 1.5;
    b {
      font-size: 16px;
      color: #0b1a30;
    }
  }
  .list-content-item-value {
    font-size: 14px;
    line-height: 1.5;
    color: #0b1a30;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
  a.list-content-item-value {
    text-decoration: underline;
  }
  .report-item {
    flex: 1;
    .report-item-header {
      height: 56px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f4f4f4;
    }
    .report-item-date {
      font-size: 14px;
      color: #6b7083;
    }
    .report-item-content {
      padding-top: 20px;
    }
  }
  .list-item-bg {
    width: 32px;
    min-width: 32px;
    height: 32px;
    background-color: #2552f3;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
